export default {

    alert_width_works: {
        "alerts": {
            "DA803650": [],
            "WBomo5rd": [
                {
                    "status_code": "A004",
                    "log_time": "2019-09-27 01:35:04",
                    "name": "\u963f\u9f9c\u6c23\u8c61\u7ad9@\u65fa\u840a\u5c71",
                    "work": [{
                        "management": "\u62c9\u906e\u5149\u7db2",
                        "url": null
                    }, {
                        "management": "\u9069\u6642\u5674\u704c",
                        "url": null
                    }]
                },
                {
                    "status_code": "A004",
                    "log_time": "2019-09-27 01:45:03",
                    "name": "\u963f\u9f9c\u6c23\u8c61\u7ad9@\u65fa\u840a\u5c71",
                    "work": [{
                        "management": "\u62c9\u906e\u5149\u7db2",
                        "url": null
                    }, {
                        "management": "\u9069\u6642\u5674\u704c",
                        "url": null
                    }]
                },
                {
                    "status_code": "A004",
                    "log_time": "2019-09-27 02:15:04",
                    "name": "\u963f\u9f9c\u6c23\u8c61\u7ad9@\u65fa\u840a\u5c71",
                    "work": [{
                        "management": "\u62c9\u906e\u5149\u7db2",
                        "url": null
                    }, {
                        "management": "\u9069\u6642\u5674\u704c",
                        "url": null
                    }]
                },
                {
                    "status_code": "A004",
                    "log_time": "2019-09-27 02:45:03",
                    "name": "\u963f\u9f9c\u6c23\u8c61\u7ad9@\u65fa\u840a\u5c71",
                    "work": [{
                        "management": "\u62c9\u906e\u5149\u7db2",
                        "url": null
                    }, {
                        "management": "\u9069\u6642\u5674\u704c",
                        "url": null
                    }]
                },
                {
                    "status_code": "A005",
                    "log_time": "2019-09-27 02:05:04",
                    "name": "\u963f\u9f9c\u6c23\u8c61\u7ad9@\u65fa\u840a\u5c71",
                    "work": []
                },
                {
                    "status_code": "A005",
                    "log_time": "2019-09-27 02:25:04",
                    "name": "\u963f\u9f9c\u6c23\u8c61\u7ad9@\u65fa\u840a\u5c71",
                    "work": []
                },
                {
                    "status_code": "A005",
                    "log_time": "2019-09-27 02:35:03",
                    "name": "\u963f\u9f9c\u6c23\u8c61\u7ad9@\u65fa\u840a\u5c71",
                    "work": []
                },
                {
                    "status_code": "A005",
                    "log_time": "2019-09-27 02:55:04",
                    "name": "\u963f\u9f9c\u6c23\u8c61\u7ad9@\u65fa\u840a\u5c71",
                    "work": []
                }
            ]
        }
    },

    project_cps_alert: {
        1: [{
                "log_time": '2018-08-14 10:30',
                "stress": 'A004', //狀態
                "device": { //裝置資訊
                    "id": "", //hashid
                    "name": "感測器 1", // 裝置名稱
                    "description": "( description ) 這是逆境描述啦啦啦啦",
                    "data": "temperature" //偵測到逆境的資料欄位
                },
                project_id: 1,
                cropperiod_id: 2,
                showModel: false, // 用來切換是否顯示詳細內容 model
            },
            {
                "log_time": '2018-08-14 10:30',
                "stress": 'A006', //狀態
                "device": { //裝置資訊
                    "id": "", //hashid
                    "name": "感測器 2", // 裝置名稱
                    "description": "( description ) 這是逆境描述啦啦啦啦",
                    "data": "temperature" //偵測到逆境的資料欄位
                },
                project_id: 1,
                cropperiod_id: 2,
                showModel: false, // 用來切換是否顯示詳細內容 model
            },
        ],
        2: [{
            "log_time": '2018-08-14 10:30',
            "stress": 'A004', //狀態
            "device": { //裝置資訊
                "id": "", //hashid
                "name": "感測器 3", // 裝置名稱
                "description": "( description ) 這是逆境描述啦啦啦啦",
                "data": "temperature" //偵測到逆境的資料欄位
            },
            project_id: 1,
            cropperiod_id: 2,
            showModel: false, // 用來切換是否顯示詳細內容 model
        }, ],
        3: [{
            "log_time": '2018-08-14 10:30',
            "stress": 'A004', //狀態
            "device": { //裝置資訊
                "id": "", //hashid
                "name": "感測器 4", // 裝置名稱
                "description": "( description ) 這是逆境描述啦啦啦啦",
                "data": "temperature" //偵測到逆境的資料欄位
            },
            project_id: 1,
            cropperiod_id: 2,
            showModel: false, // 用來切換是否顯示詳細內容 model
        }, ],
        4: [{
            "log_time": '2018-08-14 10:30',
            "stress": 'A004', //狀態
            "device": { //裝置資訊
                "id": "", //hashid
                "name": "感測器 5", // 裝置名稱
                "description": "( description ) 這是逆境描述啦啦啦啦",
                "data": "temperature" //偵測到逆境的資料欄位
            },
            project_id: 1,
            cropperiod_id: 2,
            showModel: false, // 用來切換是否顯示詳細內容 model
        }, ],
    },

    global_alert: [{
            "log_time": "2018-08-14 10:30",
            "stress": "T001",
            project_id: 1,
            cropperiod_id: 2,
            "device": {
                "id": "",
                "name": "裝置名稱",
                "description": "這是逆境描述啦啦啦啦",
                "data": "temperature"
            },
            showModel: false, // 用來切換是否顯示詳細內容 model
        },
        {
            "log_time": "2018-08-14 10:30",
            "stress": "T002",
            project_id: 1,
            cropperiod_id: 2,
            "device": {
                "id": "",
                "name": "裝置名稱",
                "description": "這是逆境描述啦啦啦啦",
                "data": "temperature"
            },
            showModel: false, // 用來切換是否顯示詳細內容 model
        },
    ],
    croppperiod_alert: {
        "alerts": {
            "DBo07v0y": [{
                    "status_code": "A003",
                    "log_time": "2018-12-13 06:14:17"
                },
                {
                    "status_code": "A003",
                    "log_time": "2018-12-13 06:24:46"
                },
                {
                    "status_code": "A003",
                    "log_time": "2018-12-13 06:35:16"
                },
                {
                    "status_code": "A003",
                    "log_time": "2018-12-13 06:45:44"
                },
                {
                    "status_code": "A003",
                    "log_time": "2018-12-13 06:56:13"
                },
                {
                    "status_code": "A003",
                    "log_time": "2018-12-13 07:06:42"
                },
                {
                    "status_code": "A014",
                    "log_time": "2018-12-13 06:14:17"
                },
                {
                    "status_code": "A014",
                    "log_time": "2018-12-13 06:24:46"
                },
                {
                    "status_code": "A014",
                    "log_time": "2018-12-13 06:35:16"
                },
                {
                    "status_code": "A014",
                    "log_time": "2018-12-13 06:45:44"
                },
                {
                    "status_code": "A014",
                    "log_time": "2018-12-13 06:56:13"
                },
                {
                    "status_code": "A014",
                    "log_time": "2018-12-13 07:06:42"
                },
                {
                    "status_code": "A014",
                    "log_time": "2018-12-13 07:17:11"
                },
                {
                    "status_code": "A003",
                    "log_time": "2018-12-13 07:17:11"
                },
                {
                    "status_code": "A014",
                    "log_time": "2018-12-13 07:27:40"
                },
                {
                    "status_code": "A003",
                    "log_time": "2018-12-13 07:27:40"
                }
            ],
            "DBoqvx08": [{
                    "status_code": "A003",
                    "log_time": "2018-12-13 06:16:10"
                },
                {
                    "status_code": "A003",
                    "log_time": "2018-12-13 06:26:40"
                },
                {
                    "status_code": "A003",
                    "log_time": "2018-12-13 06:37:08"
                },
                {
                    "status_code": "A003",
                    "log_time": "2018-12-13 06:47:37"
                },
                {
                    "status_code": "A003",
                    "log_time": "2018-12-13 06:58:08"
                },
                {
                    "status_code": "A003",
                    "log_time": "2018-12-13 07:08:36"
                },
                {
                    "status_code": "A014",
                    "log_time": "2018-12-13 06:16:10"
                },
                {
                    "status_code": "A014",
                    "log_time": "2018-12-13 06:26:40"
                },
                {
                    "status_code": "A014",
                    "log_time": "2018-12-13 06:37:08"
                },
                {
                    "status_code": "A014",
                    "log_time": "2018-12-13 06:47:37"
                },
                {
                    "status_code": "A014",
                    "log_time": "2018-12-13 06:58:08"
                },
                {
                    "status_code": "A014",
                    "log_time": "2018-12-13 07:08:36"
                },
                {
                    "status_code": "A014",
                    "log_time": "2018-12-13 07:19:04"
                },
                {
                    "status_code": "A003",
                    "log_time": "2018-12-13 07:19:04"
                },
                {
                    "status_code": "A014",
                    "log_time": "2018-12-13 07:29:33"
                },
                {
                    "status_code": "A003",
                    "log_time": "2018-12-13 07:29:33"
                }
            ],
            "WBwr4prg": []
        },
        "cropperiod_id": 3,
        "project_id": "2"
    },
}
